import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {Space} from 'antd';
import {StyledNameWithLink} from './StyledNameWithLink';
import {ExternalLinkIcon} from '../../icons';

const NameWithLink = ({
  name,
  url,
  variant = 'system',
  ...rest
}) => {

  const getLink = () => {
    if (!url) return null;

    if (variant === 'text') {
      return <ExternalLinkIcon />;
    }

    const LinkComponent = variant === 'system' ? Link : 'a';
    const linkProps = variant === 'system' ? { to: url } : { href: url };

    return (
      <LinkComponent {...linkProps} onClick={(e) => e.stopPropagation()}>
        <ExternalLinkIcon />
      </LinkComponent>
    );
  };

  const linkElement = getLink();

  return (
    <StyledNameWithLink {...rest}>
      <Space align='center' size='small'>
        {name && <span>{name}</span>}
        {linkElement}
      </Space>
    </StyledNameWithLink>
  );
}

NameWithLink.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string,
  variant: PropTypes.oneOf(['system', 'remote', 'text']),
}

export default NameWithLink;

